import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcSettings, RpcSettingsKey, RpcSettingsResult } from './rpc-settings-model';

export class RpcSettingsClient {
    /**
     * The settings request command.
     *
     * @param data the settings object.
     * @return Promise<RpcSettingsResult> the promise object of settings result.
     */
    public static settings(rpc: Rpc, data: RpcSettings): Promise<RpcSettingsResult> {
        return RpcInboundClient.call(rpc, RpcSettingsKey.command, RpcSettingsKey.version, data);
    }
}
